import Image from 'next/legacy/image';

import styles from './Banner.module.scss';

type BannerProps = {
  alt?: string;
  centered?: boolean;
  src: string;
  subtitle?: string;
  title?: string;
};

export const Banner = ({ alt = 'Banner image', centered, src, subtitle, title  }: BannerProps) => {
  return (
    <div className={styles.bannerSection}>
      <Image src={`${src}` || '/'} alt={alt} layout="fill" objectFit="cover" />
      <div className={styles.bannerCover} />
      <div className={centered ? styles.centeredBannerContent : styles.bannerContent}>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
    </div>
  );
};
